<template>
    <card-skeleton v-if="attachments?.length" class-name="ma-0 pa-0 bg-transparent" :is-loading="isLoading">
        <card-title :text="t('inquiry.attachments')" />
        <v-card-text>
            <div class="mt-0">
                <div class="d-flex flex-wrap gap-2">
                    <issue-details-single-file
                        v-for="attachment in attachments"
                        :key="attachment.id"
                        :file-name="attachment.fileName"
                        @click="generateAttachmentUrl(issueId!, attachment.id, attachment.fileName)"
                    />
                </div>
            </div>
        </v-card-text>
    </card-skeleton>
    <notification-bar
        v-model:show="notificationBarState.show"
        :color="notificationBarState.color"
        :icon="notificationBarState.icon"
        :border="notificationBarState.border"
        :message="notificationBarState.message"
    />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import CardTitle from '@/features/common/components/CardTitle.vue';
import { IIssueDetailsAttachments } from '../../types';
import { NotificationBar } from '@/features/common/components/form';
import { useFormData, useNotification } from '@/features/common/components/form/composables';
import IssueDetailsSingleFile from '@/features/issuesPage/components/Details/IssueDetailsSingleFile.vue';

const { t } = useI18n();
const { notificationBarState, notificationSuccess, notificationError } = useNotification();
const { downloadAttachment } = useFormData();
defineProps<IIssueDetailsAttachments>();

const generateAttachmentUrl = async (issueId: number, attachmentId: string, fileName: string): Promise<void> => {
    const getAttachment = await downloadAttachment(issueId, attachmentId, fileName);
    if (getAttachment) {
        notificationBarState.value = notificationSuccess(`${t('inquiry.attachmentDownloaded')} - ${fileName}`);
    } else {
        notificationBarState.value = notificationError(t('inquiry.attachmentFailed'));
    }
};
</script>
